export const lang = {
    "profit allocated to you per month": "Profit allocated to you per month",
    "total investment per month": "Total investment per month",
};

export default undefined;
